<template>
    <div>
<div v-if="!showAll">
    <span v-for="(amenity,aindex) in amenitiesLs" :key="'amenity'+aindex">
        <span v-if="aindex<5"> {{amenity+' ,'}} </span>
            </span> 
            <br />
</div>
<div v-if="showAll">
    <span v-for="(amenity,aindex) in amenitiesLs" :key="'amenity'+aindex">
        <span > {{amenity +' ,'}} </span>
            </span> 
            <br />
</div>
            <a class="active-link" @click.stop="showAll=!showAll">{{amenitiesLs.length+' '}}amenities in total </a>
    </div>
</template>
<script>
import BaseConfiguration from "../../../../config/base.js";
    import {
        COMPONENT_NAME,
        PATHNAME,DATE_TIME_FORMAT,
        FLIGHT_SELECTION_STATUS
    } from "../../../../util/constants";
export default {
    name: 'cAmenities',
        components:{
        },
        props: {
            amenitiesLs: {
                type: Array
            },
            
           
        },
        data: () => ({
            showAll:false
        }),
    
}
</script>
<style lang="scss" scoped>
.active-link {
    color: #2f85eb !important;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      text-decoration: underline !important;
    }
    
  }
</style>